import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

class LocaleStringsListItemValidate extends Component {
  state = {
    state: this.props.originalValue,
    isDirty: false
  }

  constructor (props) {
    super(props);

    this.setStringState = this.setStringState.bind(this);
  }

  setStringState (state) {
    if (state === this.state.state) {
      state = 'pending';
    }

    this.props.string.props.state = state;
    this.props.string.props.isDirty = (state !== this.props.originalValue);
    this.setState({ state: state, isDirty: this.props.string.props.isDirty });
    this.props.changesBeacon();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.originalValue !== this.props.originalValue && this.state.isDirty) {
      this.setState({ isDirty: false });
    }
  }

  getStringStatus () {
    if (this.state.isDirty) {
      return {
        text: 'edited',
        class: (
          (this.state.state === 'validated') 
            ? 'is-dirty up-for-validation' 
            : (this.state.state === 'rejected') 
              ? 'is-dirty up-for-rejection' 
              : (this.state.state === 'pending')
                ? 'pending'
                : ''
        )
      };
    }

    return {
      text: 'yes'
    };
  }

  render () {
    let status = this.getStringStatus();

    let rowStyle = {
      backgroundColor: status.color
    };

    return (
      <tr className={status.class}>
        <td className="game-context" title={this.props.string.props.context}>{this.props.string.props.context}</td>
        <td className="master" title={this.props.string.props.context}>{this.props.string.props.master}</td>
        <td title={this.props.string.props.value}>{this.props.string.props.value}</td>
        <td className="help-message">
          <button
            type="button" 
            className={(this.state.state === 'validated') ? 'button validation selected is-primary validate' : 'button validation is-primary validate'}
            onClick={() => this.setStringState('validated')}
          >
            <FontAwesomeIcon icon="check" className="icon" color="white" />
          </button>
          <button
            type="button" 
            className={(this.state.state === 'rejected') ? 'button validation selected is-primary reject' : 'button validation is-primary reject'}
            onClick={() => this.setStringState('rejected')}
          >
            <FontAwesomeIcon icon="times" className="icon" color="white" />
          </button>
        </td>
      </tr>
    );
  }
}

export default LocaleStringsListItemValidate;


// WEBPACK FOOTER //
// ./src/Components/LocaleStrings/LocaleStringsListItemValidate.js